import React, { useState, useEffect } from 'react';
import { Card, Button, Spinner, Col, Form } from 'react-bootstrap';
import axios from 'axios';
import WebNav from '../components/WebNav';
import Sidebar from '../components/Sidebar';

function Home() {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState('');
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [pageUrl, setPageUrl] = useState('');

  useEffect(() => {
    document.body.classList.add('loged-body');

    return () => {
      document.body.classList.remove('loged-body');
    };
  }, []);

  // Handle file upload and preview
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    setFilePreview(URL.createObjectURL(selectedFile)); // Show preview of the uploaded file
  };

  // Handle form submission and API call
  const handleGenerateQrCode = async (event) => {
    event.preventDefault();

    if (!title || !description || !file) {
      alert('Please fill out all fields and upload an image.');
      return;
    }

    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('image', file);

    setLoading(true); // Show loader

    try {
      const response = await axios.post('https://urqr.urqr.pro/api/create-page', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setQrCodeUrl(response.data.qr_code_url);
      setPageUrl(response.data.page_url);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false); // Hide loader
    }
  };

  const handleDownloadImage = () => {
    const downloadUrl = `https://urqr.urqr.pro/download-image?image_url=${encodeURIComponent(qrCodeUrl)}`;
    window.open(downloadUrl, '_blank');
  };

  return (
    <>
      <WebNav />
      <Sidebar />
      <div className="mt-4 login-body">
          {/* Card 1: Form */}
          <Col sm={12} md={6} lg={4}>
            <Card style={{ width: '100%' }}>
              <Card.Body>
                <Card.Title>Create a Page</Card.Title>
                <Form onSubmit={handleGenerateQrCode}>
                  <Form.Group className="mb-3">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      placeholder="Enter description"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Upload Image</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                  </Form.Group>
                  {filePreview && (
                    <div className="mb-3">
                      <p>Image Preview:</p>
                      <img
                        src={filePreview}
                        alt="Preview"
                        style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }}
                      />
                    </div>
                  )}
                  <Button variant="primary" type="submit" disabled={loading}>
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />{' '}
                        Generating...
                      </>
                    ) : (
                      'Generate QR Code'
                    )}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>

          {pageUrl && (
            <Col sm={12} md={6} lg={4}> {/* Bootstrap grid column sizes */}
              <Card className="mt-4" style={{ width: '100%' }}>
                <Card.Body>
                  <Card.Title>Generated Page Url QR Code</Card.Title>
                  <Card.Img
                    src={qrCodeUrl}
                    alt="Generated Page QR Code"
                    style={{ width: '150px', height: '200px', objectFit: 'contain' }}
                  />
                  <Button variant="primary" onClick={handleDownloadImage}>
                    Download
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          )}
      </div>
    </>
  );
}

export default Home;
